// report-sections.ts
import { UniversalReportRendererComponent } from '../universal-report-renderer/universal-report-renderer.component';

export interface ReportSection {
  id: string;
  title: string;
  component: any;
  display: boolean;
  print: boolean;
  data?: Record<string, any>;
}

export function buildReportSections(data: any, pdfView: boolean, reportSpec?: any): ReportSection[] {
  if (!reportSpec) {
    console.warn('Report requires a spec to be rendered');
    return [];
  }

  return reportSpec.tabs.map((tab: any) => ({
    id: tab.id,
    title: tab.title,
    component: UniversalReportRendererComponent,
    display: tab.display,
    print: true,
    data: { tab: tab, printMode: pdfView }
  }));
}

export function updateSectionProps(sections: ReportSection[], sectionId: string, data: Record<string, any>): ReportSection[] {
  return sections.map(section =>
    section.id === sectionId ? { ...section, data: { ...section.data, ...data } } : section
  );
}

export function updateSectionVisibility(sections: ReportSection[], sectionId: string, display: boolean, print: boolean): ReportSection[] {
  return sections.map(section =>
    section.id === sectionId ? { ...section, display, print } : section
  );
}
